import { render, staticRenderFns } from "./ResourcesExternalLinkJumbotrons.vue?vue&type=template&id=a89c7a46"
import script from "./ResourcesExternalLinkJumbotrons.vue?vue&type=script&lang=ts"
export * from "./ResourcesExternalLinkJumbotrons.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports